module.exports = __webpack_public_path__ + "assets/img/2_773.8aef48b4.jpg";